<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="id" size="lg" title="Nieuw dossieritem">
    <snelstart-ui-dialog-body [formGroup]="dossierItemFg">
        <div class="row col-auto pt-2">
            <div class="col-6 ">
                Titel
            </div>
            <div class="col-6">
                <snelstart-ui-text-form-control class="custom-input-250"
                                                formControlName="title"
                                                id="title"
                >
                </snelstart-ui-text-form-control>
            </div>
        </div>

        <div class="row col-auto">
            <div class="col-6 ">
                Aangemaakt door
            </div>
            <div class="col-6">
                <snelstart-ui-text-form-control class="custom-input-250"
                                                formControlName="creator"
                                                id="creator"
                >
                </snelstart-ui-text-form-control>
            </div>
        </div>

        <div class="row col-auto">
            <div class="col-6 ">
                Notitie
            </div>
            <div class="col-6">
                <snelstart-ui-textarea-form-control [rows]="6"
                                                    class="custom-input-250"
                                                    formControlName="opmerkingen"
                                                    id="opmerkingen">
                </snelstart-ui-textarea-form-control>
            </div>
        </div>

        <!--        <div class="row col-auto">-->
        <!--            <div class="col-6 ">-->
        <!--                Deadline-->
        <!--            </div>-->
        <!--            <div class="col-6">-->
        <!--                <snelstart-ui-date-form-control class="custom-input-250"-->
        <!--                                                formControlName="dateDeadline"-->
        <!--                                                id="dateDeadline">-->
        <!--                </snelstart-ui-date-form-control>-->
        <!--            </div>-->
        <!--        </div>-->


        <!--        <snelstart-ui-text-form-control class="custom-input-250"-->
        <!--                                        formControlName="attachment"-->
        <!--                                        id="attachment"-->
        <!--                                        label="Attachment">-->
        <!--        </snelstart-ui-text-form-control>-->
        <div class="row col-auto">
            <div class="col-6">
                <p>Bijlage</p>
            </div>
            <div class="col-6">
                <div class="file-upload">
                    <input #fileUpload (change)="onFileSelected($event)" class="file-input" type="file">
                    <snelstart-ui-button (click)="fileUpload.click()" class="custom-input-250"
                                         icon="paperclip-vertical"
                                         type="secondary"
                    >
                        Voeg bijlage toe (max. 5Mb)
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
        <div>
            @if (isZipTooLarge) {
                <snelstart-ui-alert type="warning">
                    Het bijgevoegde bestand is te groot. Het maximaal toegestane bestandsformaat is 5MB.
                </snelstart-ui-alert>
            }
            @if (dossierItemFg.get('attachment')?.value !== null) {
                <div class="row col-auto pt-2 pb-2">
                    <div class="col-6">
                        <p></p>
                    </div>
                    <div class="col-6">
                        <snelstart-ui-button (click)="toonPdf()"
                                             icon="file-export"
                                             class="custom-input-250"
                                             type="primary">
                            Toon bijlage
                        </snelstart-ui-button>
                    </div>
                </div>
            }
        </div>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button (click)="dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                             type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button [config]="config()" [disabled]="this.isZipTooLarge" icon="check" id="save"
                             type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
